var map = {
	"./africa": 617,
	"./africa.js": 617,
	"./australia": 706,
	"./australia.js": 706,
	"./bangladesh": 707,
	"./bangladesh.js": 707,
	"./global": 708,
	"./global.js": 708,
	"./india": 709,
	"./india.js": 709,
	"./newzealand": 710,
	"./newzealand.js": 710,
	"./pakistan": 711,
	"./pakistan.js": 711,
	"./srilanka": 712,
	"./srilanka.js": 712,
	"./taboola": 704,
	"./taboola.js": 704,
	"./unitedkingdom": 713,
	"./unitedkingdom.js": 713,
	"./unitedstates": 714,
	"./unitedstates.js": 714
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	return map[req] || (function() { throw new Error("Cannot find module '" + req + "'.") }());
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 616;



//////////////////
// WEBPACK FOOTER
// ../app/lib/utils/editions/config/cricinfo ^\.\/.*$
// module id = 616
// module chunks = 0